/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: KUFcRsF9ovEF
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ModuleNav from "../../ModuleNav"; // plasmic-import: wOh_p_z-r3kg/component
import LeftSectionNav from "../../LeftSectionNav"; // plasmic-import: LqMwNzsXjkO-/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicBottomNav.module.css"; // plasmic-import: KUFcRsF9ovEF/css

createPlasmicElementProxy;

export const PlasmicBottomNav__VariantProps = new Array("type");

export const PlasmicBottomNav__ArgProps = new Array(
  "navModule2",
  "nameWrapper",
  "navModule"
);

const $$ = {};

function PlasmicBottomNav__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.type
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"navbarWrapper"}
      data-plasmic-override={overrides.navbarWrapper}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.navbarWrapper,
        {
          [sty.navbarWrappertype_withRightModule]: hasVariant(
            $state,
            "type",
            "withRightModule"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"moduleSlot2"}
        data-plasmic-override={overrides.moduleSlot2}
        className={classNames(projectcss.all, sty.moduleSlot2, {
          [sty.moduleSlot2type_withRightModule]: hasVariant(
            $state,
            "type",
            "withRightModule"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <ModuleNav
              byPlacement={"navOnboarding"}
              className={classNames("__wab_instance", sty.moduleNav__k8GyL)}
            />
          ),

          value: args.navModule2
        })}
      </div>
      <div
        data-plasmic-name={"titleOnboarding2"}
        data-plasmic-override={overrides.titleOnboarding2}
        className={classNames(projectcss.all, sty.titleOnboarding2, {
          [sty.titleOnboarding2type_withRightModule]: hasVariant(
            $state,
            "type",
            "withRightModule"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <LeftSectionNav
              bottomNav={"defaultOnboarding"}
              className={classNames(
                "__wab_instance",
                sty.leftSectionNav__ri75N
              )}
              topNav={"tabTitle"}
            />
          ),

          value: args.nameWrapper
        })}
      </div>
      <div
        data-plasmic-name={"moduleSlot"}
        data-plasmic-override={overrides.moduleSlot}
        className={classNames(projectcss.all, sty.moduleSlot)}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <ModuleNav
              byPlacement={"navOnboarding"}
              className={classNames("__wab_instance", sty.moduleNav__ayKi)}
            />
          ),

          value: args.navModule
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  navbarWrapper: [
    "navbarWrapper",
    "moduleSlot2",
    "titleOnboarding2",
    "moduleSlot"
  ],

  moduleSlot2: ["moduleSlot2"],
  titleOnboarding2: ["titleOnboarding2"],
  moduleSlot: ["moduleSlot"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBottomNav__ArgProps,
          internalVariantPropNames: PlasmicBottomNav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBottomNav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "navbarWrapper") {
    func.displayName = "PlasmicBottomNav";
  } else {
    func.displayName = `PlasmicBottomNav.${nodeName}`;
  }
  return func;
}

export const PlasmicBottomNav = Object.assign(
  // Top-level PlasmicBottomNav renders the root element
  makeNodeComponent("navbarWrapper"),
  {
    // Helper components rendering sub-elements
    moduleSlot2: makeNodeComponent("moduleSlot2"),
    titleOnboarding2: makeNodeComponent("titleOnboarding2"),
    moduleSlot: makeNodeComponent("moduleSlot"),
    // Metadata about props expected for PlasmicBottomNav
    internalVariantProps: PlasmicBottomNav__VariantProps,
    internalArgProps: PlasmicBottomNav__ArgProps
  }
);

export default PlasmicBottomNav;
/* prettier-ignore-end */
